<unity-dropdown-control
  [displayName]="$displayName()"
  [description]="$description()"
  [values]="$enabledPrograms()"
  [valuePrimitive]="true"
  [control]="$control()"
  [defaultItem]="$defaultItem()"
  [showHint]="$showHint()"
  (selectionChange)="onSelectionChange($event)" />
